<template>
  <div>
    <form @submit.prevent="submit()">
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'modulo'"
            v-model="formulario.modulo" 
            :placeholder="'Nome'"
            data-vv-as="Nome"
            v-validate="'required|max:255'"
            :error="validationErrors.first('modulo')"
         />
      </div>      
      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioModuloComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    modulo: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.modulo || {
        modulo: ''
      }
    }
  },
  computed: {
    ...mapGetters('modulos', ['listaDeModulos'])
  },
  methods: {
    ...mapActions('modulos', [
      'salvarModulo',
      'atualizarModulo'
    ]),
     validate: function () {
          this.$validator.validateAll();
        },
     limparCampos () {
       this.formulario.modulo = '';
        this.$validator.reset();
     },   
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarModulo(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
              const resp = await this.atualizarModulo(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }


}
</script>